export default __webpack_public_path__ + "static/media/aside-vip-logo-default.802da7ab.webp";